import { InsightHeader } from "@components/insight/InsightHeader"
import { defineBlock } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "Insight Header",
  icon: "block-default",
  postMetaBlock: {
    fieldName: "insightHeader",
    postTypes: ["insight"],
  },
  conditions: {
    postTypes: ["insight"],
  },
}

export default defineBlock("insight/insight-header", (props) => {
  return (
    <InsightHeader
      title={props.insight?.title || ""}
      type={props.type?.insightType?.titleSingular || ""}
      typeSlug={props.type?.slug || ""}
      typeUri={props.type?.uri || ""}
      categories={props.icategories || []}
      displayedDate={props.displayedDate || ""}
      headline={props.headline}
      featuredImage={props.featuredImage || null}
      personnel={props.personnel}
      formId={props.hubspotFormId}
    />
  )
})
